<template>
  <div class="page__comm--wrap clearfix">
    <div class="inner_paging">
      <a href="#none" class="btn_paging"
        :class="{ disabled: !hasPage || isFirstPage }"
        @click.prevent="onPageChange(1)">
        {{ $t('common.pagination.first') }}
        <span class="icon icon--end--left disabled"></span>
      </a>
      <a href="#none" class="btn_paging"
        :class="{ disabled: !hasPage || !hasPrevBlock }"
        @click.prevent="onPrevBlockClick">
        {{ $t('common.pagination.prev') }}
        <span class="icon icon--left disabled"></span>
      </a>
      <ol v-if="hasPage" class="list_page">
        <li v-for="pageNo in pages" :key="pageNo">
          <a href="#none" class="link_page"
            :class="{ on: pageNo === page }"
            @click.prevent="onPageChange(pageNo)">{{ pageNo }}</a>
        </li>
      </ol>
      <a href="#none" class="btn_paging"
        :class="{ disabled: !hasPage || !hasNextBlock }"
        @click.prevent="onNextBlockClick">
        {{ $t('common.pagination.next') }}
        <span class="icon icon--right"></span>
      </a>
      <a href="#none" class="btn_paging"
        :class="{ disabled: !hasPage || isLastPage }"
        @click.prevent="onPageChange(pageSize)">
        {{ $t('common.pagination.last') }}
        <span class="icon icon--end--right"></span>
      </a>
    </div>
    <span class="txt_page">{{ hasPage ? page : 0 }}/{{ pageSize }}</span>
    <span class="txt_info">{{ $t('common.pagination.viewPerPage') }}</span>
    <ui-selectbox
      class="some-class"
      :value="limit"
      :items="limitList"
      @input="onLimitChange"
    />
    <slot name="filter"/>
  </div>
</template>

<script>
import UiSelectbox from '@/components/ui/UiSelectbox'

export default {
  name: 'AppPagination',
  components: {
    UiSelectbox
  },
  props: {
    total: {
      type: Number,
      required: true
    },
    page: {
      type: Number,
      required: true
    },
    pagingBlock: {
      type: Number,
      default: 5
    },
    limit: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      limitList: [30, 50, 100]
    }
  },
  computed: {
    hasPage () {
      return !!this.total
    },
    pageSize () {
      return Math.ceil(this.total / this.limit)
    },
    blockSize () {
      return Math.ceil(this.pageSize / this.pagingBlock)
    },
    currentBlock () {
      return Math.ceil(this.page / this.pagingBlock)
    },
    hasPrevBlock () {
      return this.currentBlock > 1
    },
    hasNextBlock () {
      return this.currentBlock < this.blockSize
    },
    isFirstPage () {
      return this.page === 1
    },
    isLastPage () {
      return this.page === this.pageSize
    },
    pages () {
      const pages = []
      const startPage = (this.currentBlock - 1) * this.pagingBlock + 1
      const endPage = Math.min(startPage + this.pagingBlock - 1, this.pageSize)
      for (let i = startPage; i <= endPage; i++) {
        pages.push(i)
      }
      return pages
    }
  },
  methods: {
    onPageChange (page) {
      this.$emit('onPagingOptionChange', page, this.limit)
    },
    onPrevBlockClick () {
      const newPage = (this.currentBlock - 1) * this.this.pagingBlock
      this.onPageChange(newPage)
    },
    onNextBlockClick () {
      const newPage = (this.currentBlock) * this.pagingBlock + 1
      this.onPageChange(newPage)
    },
    onLimitChange (limit) {
      this.$emit('onPagingOptionChange', 1, limit)
    }
  }
}
</script>

<style lang="scss" scoped>
.page__comm--wrap{
  position:relative;
  width:100%;
  display:flex;
  align-items: center;
  margin-bottom: 20px; // from .page__comm--wrap + .inner_tbl { margin-top: 20px; }
  .inner_paging{
    display:inline-block;
  }
  .btn_paging{
    display:inline-block;
    width:30px;
    height:30px;
    border-radius: 5px;
    border: solid 1px #d7d7d7;
    background-color: #fff;
    text-indent:-9999px;
    font-size: 0;
    line-height: 0;
    vertical-align: top;
    .icon{
      display:block;
      margin:9px 9px auto;
    }
    &.disabled {
      pointer-events: none;
      .icon {
        opacity: 0.3;
      }
    }
  }
  .list_page{
    display:inline-block;
    margin:0 5px;
    border-radius: 5px;
    border: solid 1px #d7d7d7;
    background-color:#fff;
    li{
      display:inline-block;
      width:30px;
      height:30px;
      border-left: solid 1px #d7d7d7;
      font-size:13px;
      text-align:center;
      line-height:30px;
      &:first-child{
        border-left:0;
      }
      .link_page{
        display:block;
        width:30px;
        height:30px;
        color:#444;
      }
      .link_page.on{
        color:#fc004e;
      }
    }
  }
  .btn_paging + .btn_paging{
    margin-left:5px;
  }
  .txt_page{
    display:inline-block;
    padding-left:15px;
  }
  .txt_info{
    display:inline-block;
    font-size:13px;
    color:#767676;
  }
  .txt_page + .txt_info{
    &:before{
      content:'';
      float:left;
      margin:0 15px;
      width: 1px;
      height: 14px;
      background-color: #d7d7d7;
    }
  }
  .some-class{
    width:91px;
    margin-left:10px;
  }
  .btn_filter{
    position:absolute;
    top:50%;
    right:0;
    margin-top:-8px;
    color:#444;
    line-height:16px;
    .icon--filter{
      display:inline-block;
      margin-right:5px;
      vertical-align: top;
    }
  }
}
.page__comm--wrap + .inner_tbl{
  margin-top:20px;
}
</style>
